document.addEventListener("DOMContentLoaded", () => {
  const target = document.querySelector("#trustmate-target");
  if (!target) return;

  const findWidget = () => document.querySelector("div.hydra") || document.querySelector("div.tm-hydra");

  const move = () => {
    const widget = findWidget();
    if (!widget || target.contains(widget)) return Boolean(widget);
    target.appendChild(widget);
    return true;
  };

  if (move()) return;

  const observer = new MutationObserver(() => {
    if (move()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});